import type { ValueOf } from '../util/typeUtils';

export const API_ROUTES = {
    activeDaysByMonth: 'activeDaysByMonth',
    agreeAdvertisementConsent: 'agreeAdvertisementConsent',
    avatar: 'avatar',
    bankOfferDocumentsDownload: 'bankOfferDocumentsDownload',
    certificateUpload: 'certificateUpload',
    chatMediaDownload: 'chatMediaDownload',
    chatMediaUpload: 'chatMediaUpload',
    checkJwt: 'checkJwt',
    checkOldPlaceholders: 'checkOldPlaceholders',
    createApplicantRoutine: 'createApplicantRoutine',
    createCorporationRoutine: 'createCorporationRoutine',
    createDivisionRoutine: 'createDivisionRoutine',
    createTeamRoutine: 'createTeamRoutine',
    createUserRoutine: 'createUserRoutine',
    documentDownload: 'documentDownload',
    documentUpload: 'documentUpload',
    documentVerify: 'documentVerify',
    emit: 'emit',
    events: 'events',
    eventsByAggregate: 'eventsByAggregate',
    fields: 'fields',
    firstLoginsOfDay: 'firstLoginsOfDay',
    getAdvertisementConsentInfo: 'getAdvertisementConsentInfo',
    getLastActions: 'getLastActions',
    getTrustpilotProfile: 'getTrustpilotProfile',
    getVerifyInfo: 'getVerifyInfo',
    getWhatsappPhoneNumbers: 'getWhatsappPhoneNumbers',
    healthcheck: 'healthcheck',
    lastActions: 'lastActions',
    loanRequest: 'loanRequest',
    manualOfferDownload: 'manualOfferDownload',
    offerRecord: 'offerRecord',
    partnerSyncStatus: 'partnerSyncStatus',
    prepareSystemMails: 'prepareSystemMails',
    previewCancelMail: 'previewCancelMail',
    previewStatusMail: 'previewStatusMail',
    recalculateLeadFlags: 'recalculateLeadFlags',
    register: 'register',
    registration: 'registration',
    resetPassword: 'resetPassword',
    resetSecret: 'resetSecret',
    retryLeadAttributionRequests: 'retryLeadAttributionRequests',
    sendEmailMessage: 'sendEmailMessage',
    sendTestEmail: 'sendTestEmail',
    step: 'step',
    syncPartners: 'syncPartners',
    tfaInit: 'tfaInit',
    tfaTest: 'tfaTest',
    tmpSecretHandler: 'tmpSecretHandler',
    updateCorporationRoutine: 'updateCorporationRoutine',
    updateDivisionRoutine: 'updateDivisionRoutine',
    updateTeamRoutine: 'updateTeamRoutine',
    updateUserRoutine: 'updateUserRoutine',
    utils: 'utils',
    verifyEmail: 'verifyEmail',
} as const;

export type API_ROUTE = ValueOf<typeof API_ROUTES>;
